import { DexecureImageOptions } from '@utils/cloudAssetUrl.util';

/**
 * Shared by the rendered hero `<img>` (via CloudImage) and the `<link rel="preload">` on
 * /registry/, so both resolve to the same URL through `cloudAssetUrl`.
 *
 * These used to be declared independently: the preload pointed at the bare asset path while
 * CloudImage requested `?m_resize=w400&opt=aggressive&ver=2`. Two URLs meant the browser
 * downloaded the hero twice and the preload never warmed the image the page actually used
 * (GROW-1802).
 */
export const REGISTRY_HERO_IMAGE_SRC = 'registry-q12024/hero/wedding-registry-hero-image.webp';

export const REGISTRY_HERO_IMAGE_OPTIONS: DexecureImageOptions = {
  optimization: 'aggressive',
  mobileResizeWidth: 400,
};
